export const DEFAULT_TITLE = 'Filtros'
export const DEFAULT_SUBTITLE = 'Filtre o que deseja ver.'
